import { useState } from "react";
import { Monitor, X } from "lucide-react";

/**
 * Mobile-only, dismissible hint shown at the top of data-dense panels
 * (seller / professional / instructor dashboards) suggesting the desktop site
 * for the full management experience. Hidden entirely on md+ screens.
 *
 * Dismissal persists per panel for the session (sessionStorage) so it doesn't
 * nag on every navigation, but returns in a new session.
 */
export default function DesktopRecommendedBanner({ panel }: { panel: string }) {
  const storageKey = `drx.desktopHint.dismissed.${panel}`;
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(storageKey) === "1";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  return (
    <div className="md:hidden mb-4 flex items-start gap-3 rounded-lg border border-cyan-500/30 bg-cyan-500/10 px-3 py-2.5 text-sm text-cyan-100">
      <Monitor className="mt-0.5 h-4 w-4 shrink-0 text-cyan-300" />
      <p className="flex-1 leading-snug">
        This dashboard works best on a larger screen. For the full management
        experience, open DanceRealmX on a desktop or tablet.
      </p>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => {
          try {
            sessionStorage.setItem(storageKey, "1");
          } catch {
            /* ignore */
          }
          setDismissed(true);
        }}
        className="shrink-0 rounded p-0.5 text-cyan-300/80 hover:bg-cyan-500/20 hover:text-white"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
